export let authorizeStatusObj = {
    "no_authorize": "未授权",
    "expire": "授权已过期",
    "soon_expire": "授权即将到期",
    "normal":"授权正常"
}